export interface AuthorizationUserProfile {
  personName: string;
  socialName: string | null;
}

export function getAuthorizationDisplayName(profile: AuthorizationUserProfile | null): string {
  if (!profile) {
    return '';
  }

  const socialName = profile.socialName?.trim();
  if (socialName) {
    return socialName;
  }

  return profile.personName?.trim() ?? '';
}

/** Iniciais do primeiro e segundo nome (ex.: Felipe Alencar Giacomini → FA). */
export function getFirstTwoNameInitials(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);

  if (!parts.length) {
    return '';
  }

  if (parts.length === 1) {
    return parts[0].substring(0, 2).toUpperCase();
  }

  return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
}
